import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import classNames from '../../node_modules/classnames/index.js';
import { ExclamationCircleFill } from '@livingdesign/icons';
import { componentFormHelperTextIconStateErrorIconSize } from '@livingdesign/tokens/dist/js/light/regular/components/Form';
import styles from './FormHelperText.module.scss.js';
import '@walmart-web/livingdesign-components/index.esm.css';
import { Caption } from '@walmart-web/livingdesign-components';
import '../Alert/Alert.js';
import '../Button/Button.js';
import '../Button/ButtonGroup.js';
import '../Radio/Radio.js';
import '../Tag/Tag.js';
import '../Checkbox/Checkbox.js';
import '../Chip/Chip.js';
import '../IconButton/IconButton.js';
import '../TextField/TextField.js';
import '../TabNavigation/TabNavigation.js';
import '../TabNavigation/TabNavigationItem.js';
import '../Modal/Modal.js';
import '@livingdesign/tokens/dist/js/light/regular/components/ErrorMessage';
import '../SearchBox/SearchBox.js';
import '../AutoComplete/AutoComplete.js';
import '../TextArea/TextArea.js';
import '../ProgressIndicator/ProgressIndicator.js';
import '../Panel/Panel.js';
import '../Calendar/locale/wmLocale.js';
import '../Calendar/locale/stdLocale.js';
import '../Calendar/context.js';
import 'dayjs';
import '../Calendar/RenderDays.js';
import '../Calendar/RenderWeeks.js';
import '../utility/constants.js';
import '@react-aria/ssr';
import '../CardActionArea/CardActionArea.js';
import '../HierarchySelector/HierarchySelector.js';
import '../Pagination/Pagination.js';
import '../DisplayTag/DisplayTag.js';
import '../PageHeader/PageHeader.js';
import '../Table/Table.js';
import '../Tooltip/Tooltip.js';
import '../ValueChange/ValueChange.js';

var _excluded = ["UNSAFE_className", "className", "children", "disabled", "hasError"];
/**
 * @private
 */
var FormHelperText = function FormHelperText(props) {
  var UNSAFE_className = props.UNSAFE_className,
    className = props.className,
    children = props.children,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$hasError = props.hasError,
    hasError = _props$hasError === void 0 ? false : _props$hasError,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React__default.createElement(Caption, _extends({
    UNSAFE_className: classNames(styles.helperText, disabled && styles.disabled, hasError && styles.hasError, UNSAFE_className, className)
  }, rest), hasError && /*#__PURE__*/React__default.createElement(ExclamationCircleFill, {
    className: styles.icon,
    size: componentFormHelperTextIconStateErrorIconSize
  }), children);
};

export { FormHelperText };
